import { api } from "@shared/api/client";
import type { GlobalNavigationTarget } from "@shared/navigation/globalNavigation";

export type GlobalSearchResultType =
  | "apartado"
  | "subapartado"
  | "seccion"
  | "subseccion"
  | "usuario"
  | "cliente"
  | "proyecto"
  | "valoracion"
  | "contacto"
  | "campana"
  | "empresa"
  | "departamento";

export interface GlobalSearchResult {
  type: GlobalSearchResultType;
  section: string;
  title: string;
  subtitle: string | null;
  meta: string | null;
  badge?: string | null;
  url: string;
  navigation?: GlobalNavigationTarget;
  searchKeywords?: string[];
}

interface GlobalSearchResponse {
  data: GlobalSearchResult[];
  meta: {
    query: string;
    count: number;
  };
}

export async function searchGlobal(
  query: string,
  signal?: AbortSignal,
): Promise<GlobalSearchResult[]> {
  const { data } = await api.get<GlobalSearchResponse>("/search", {
    params: { q: query },
    signal,
  });

  return data.data;
}
